import React from "react";
import NotFound from "../components/Common/NotFound";
import Container from "../components/Layouts/Container";

import { useDispatch } from "react-redux";
import { setIsNotFound } from "../store/Slice/pageNotFoundSlice";
import { getMetaDetailList } from "../store/Slice/metaDetailsSlice";

const NotFoundPage = () => {
  const dispatch = useDispatch();

  // const isNotFound = useSelector((state) => state.pageNotFound.isNotFound);

  React.useEffect(() => {
    dispatch(setIsNotFound(true));
    dispatch(getMetaDetailList({ vSlug: "page-not-found" }));
    // cleanup when leaving 404
    return () => {
      dispatch(setIsNotFound(false));
    };
  }, [dispatch]);

  return (
    <Container>
      <NotFound />
    </Container>
  );
};

export default NotFoundPage;
